import {BoardColumnData, BoardColumnKey} from '../../../../../hooks/useMatchesBoardColumnsSorting';

export function filterBoardColumnsBySearchTerm(
  columns: Record<BoardColumnKey, BoardColumnData>,
  searchTerm: string
): Record<BoardColumnKey, BoardColumnData> {
  const normalizedSearchTerm = searchTerm.trim().toLowerCase();

  if (!normalizedSearchTerm) {
    return columns;
  }

  const filterMatches = (matches: BoardColumnData['matches']) =>
    matches.filter((match) => {
      const firstName = match.applicant?.personalInformation?.firstName ?? '';
      const lastName = match.applicant?.personalInformation?.lastName ?? '';
      const fullName = `${firstName} ${lastName}`.trim().toLowerCase();
      return fullName.includes(normalizedSearchTerm);
    });

  return {
    new: {
      ...columns.new,
      matches: filterMatches(columns.new.matches),
    },
    contacted: {
      ...columns.contacted,
      matches: filterMatches(columns.contacted.matches),
    },
    interview: {
      ...columns.interview,
      matches: filterMatches(columns.interview.matches),
    },
  };
}
